var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting-field",
      class: { "disable-html-component": _vm.missing },
    },
    [
      _c(
        "el-badge",
        {
          staticClass: "label",
          attrs: { value: "error", hidden: !_vm.missing },
        },
        [_c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")])]
      ),
      _vm._v(" "),
      _c("el-input-number", {
        style: { textAlign: "left", width: "100%" },
        attrs: {
          "controls-position": "right",
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
          precision: _vm.precision,
          size: "small",
          disabled: _vm.disabled,
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.config.value,
          callback: function ($$v) {
            _vm.$set(_vm.config, "value", $$v)
          },
          expression: "config.value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }